const textFieldModalPlaces = {
  name: 'Name',
  childLabel: 'Type of branch',
  helperText: 'E.g.: site, department, room, shed, ...',
  latitude: 'Latitude',
  longitude: 'Longitude'
};

export default textFieldModalPlaces;
